import type { TourStep } from '@/types/help-tour';
import { buildTourSteps, type TourStepDef } from '@/utils/tourI18n';

const STEP_DEFS: TourStepDef[] = [
  { target: '[data-tour="members-intro"]' },
  { target: '[data-tour="members-invite"]' },
  { target: '[data-tour="members-filters"]' },
  { target: '[data-tour="members-grid"]', spotlightFirstRow: true }
];

export const FAMILY_MEMBERS_TOUR_STEPS: TourStep[] = buildTourSteps('familyMembers', STEP_DEFS);

export const FAMILY_MEMBERS_TOUR_STORAGE_KEY = 'wetree-family-members-tour-completed';

export function resolveFamilyMembersTourSteps(
  steps: TourStep[],
  hasResults: boolean,
  canInviteMembers = false
): TourStep[] {
  return steps.filter((step) => {
    if (step.target === '[data-tour="members-invite"]') {
      return canInviteMembers;
    }
    if (!hasResults && step.target === '[data-tour="members-grid"]') {
      return false;
    }
    return true;
  });
}
